import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { colspan: "2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-d-flex p-justify-end p-mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Total brut :", -1)
const _hoisted_5 = { class: "p-text-right" }
const _hoisted_6 = { class: "p-text-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Total Net :", -1)
const _hoisted_8 = { class: "p-text-right" }
const _hoisted_9 = { class: "p-text-right" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_ProductName = _resolveComponent("ProductName")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.ticket.sequence.terminal.name), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.$t("pos.sequence")), 1),
        _createElementVNode("td", null, [
          _createVNode(_component_NumberFormatter, {
            value: _ctx.ticket.sequence.number
          }, null, 8, ["value"])
        ])
      ]),
      (_ctx.ticket.number > 0)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.ticketNumber")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.ticket.number), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.$t("date")), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.ticket.createdAt, _ctx.$t("format.ticketDate"))), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.client")), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.ticket.customer?.name || "Comptoir"), 1)
      ])
    ]),
    _createVNode(_component_DataTable, {
      value: (_ctx.ticket.movements as any),
      paginator: false,
      class: "p-datatable-sm",
      rows: _ctx.ticket.movements.length,
      dataKey: "id",
      rowHover: false,
      loading: _ctx.loading,
      "show-gridlines": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: _ctx.$t('stock.product'),
          field: "product.name"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_ProductName, {
              product: data.product
            }, {
              default: _withCtx(({ name }) => [
                _createTextVNode(_toDisplayString(name), 1)
              ]),
              _: 2
            }, 1032, ["product"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('product.reference'),
          field: "product.reference"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_ProductName, {
              product: data.product
            }, {
              default: _withCtx(({ reference }) => [
                _createTextVNode(_toDisplayString(reference), 1)
              ]),
              _: 2
            }, 1032, ["product"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('payment.quantity'),
          field: "quantity"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_NumberFormatter, {
              value: _ctx.sign * data.quantity
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('payment.total'),
          "header-class": "p-d-flex p-justify-end",
          "body-class": "p-text-right"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_NumberFormatter, {
              value: _ctx.sign * data.quantity * data.price
            }, null, 8, ["value"]),
            _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading"]),
    _createVNode(_component_DataTable, {
      value: (_ctx.ticket?.payments as any),
      paginator: false,
      class: "p-datatable-sm p-mt-3",
      rows: _ctx.ticket?.payments?.length,
      dataKey: "id",
      rowHover: false,
      loading: _ctx.loading,
      "show-gridlines": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("th", null, _toDisplayString(_ctx.$t("payment.previous")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: _ctx.$t('date'),
          field: "createdAt"
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('product.type'),
          field: "method"
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.$tm("payment.methods")[data.method]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('payment.amount'),
          field: "amount"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_NumberFormatter, {
              value: 
            _ctx.sign *
            (data.method === 3
              ? _ctx.resume.offerAmount
              : data.received - data.change)
          
            }, null, 8, ["value"]),
            _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('payment.note'),
          field: "note"
        }, null, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_NumberFormatter, {
                value: _ctx.resume.total
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("payment.discount")) + " ", 1),
              _createVNode(_component_NumberFormatter, {
                value: _ctx.resume.percentage
              }, null, 8, ["value"]),
              _createTextVNode(" % : ")
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_NumberFormatter, {
                value: _ctx.resume.offerAmount
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_NumberFormatter, {
                value: _ctx.resume.totalNet
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.payed")) + " :", 1),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_NumberFormatter, {
                value: _ctx.resume.received
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ])
          ]),
          (_ctx.resume.sold > 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.sold")) + " :", 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_NumberFormatter, {
                    value: _ctx.resume.sold
                  }, null, 8, ["value"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}